import {
  DomainsType,
  EventType,
  ParameterType,
  QueryType,
  UrlType,
  StrictEventTypeRecord,
  StrictFirstParameterRecord,
  StrictParameterRecord,
  StrictQueryRecord,
  StrictTrackingRecord,
  TrackingType,
} from './types';

export const NUMBER_OF_RETRIES = 2;

export enum Header {
  UserAgent = 'User-Agent',
  ContentType = 'Content-Type',
  SdkVersion = 'X-Kameleoon-SDK-Version',
  SdkType = 'X-Kameleoon-SDK-Type',
  Authorization = 'Authorization',
  AcceptEncoding = 'Accept-Encoding',
  IfModifiedSince = 'If-Modified-Since',
  LastModified = 'Last-Modified',
}

export const UrlEventType: StrictEventTypeRecord<EventType> = {
  CustomData: 'eventType=customData',
  StaticData: 'eventType=staticData',
  Page: 'eventType=page',
  Conversion: 'eventType=conversion',
  Activity: 'eventType=activity',
  Experiment: 'eventType=experiment',
  Geolocation: 'eventType=geolocation',
  TargetingSegment: 'eventType=targetingSegment',
};
export const UrlParameter: StrictParameterRecord<ParameterType> = {
  Title: '&title=',
  ReferrersIndices: '&referrersIndices=',
  Negative: '&negative=',
  Revenue: '&revenue=',
  Overwrite: '&overwrite=',
  Index: '&index=',
  BrowserIndex: '&browserIndex=',
  BrowserVersion: '&browserVersion=',
  Href: '&href=',
  DeviceType: '&deviceType=',
  SiteCode: '&siteCode=',
  GoalId: '&goalId=',
  VisitorCode: '&visitorCode=',
  VariationId: '&variationId=',
  Ts: '&ts=',
  Key: '&key=',
  SdkName: '&sdkName=',
  SdkVersion: '&sdkVersion=',
  ValuesCountMap: '&valuesCountMap=',
  Nonce: '&nonce=',
  Id: '&id=',
  CustomData: '&customData=',
  CurrentVisit: '&currentVisit=',
  MaxNumberPreviousVisits: '&maxNumberPreviousVisits=',
  Os: '&os=',
  OsIndex: '&osIndex=',
  Country: '&country=',
  City: '&city=',
  Region: '&region=',
  Latitude: '&latitude=',
  Longitude: '&longitude=',
  PostalCode: '&postalCode=',
  Conversion: '&conversion=',
  StaticData: '&staticData=',
  Geolocation: '&geolocation=',
  Page: '&page=',
  Experiment: '&experiment=',
  Browser: '&browser=',
  Environment: '&environment=',
  MappingIdentifier: '&mappingIdentifier=',
  MappingValue: '&mappingValue=',
  Kcs: '&kcs=',
  Personalization: '&personalization=',
  UserAgent: '&userAgent=',
  BodyUa: '&bodyUa=',
  Cbs: '&cbs=',
  Metadata: '&metadata=',
  VisitNumber: '&visitNumber=',
  TimeSincePreviousVisit: '&timeSincePreviousVisit=',
};
export const UrlFirstParameter: StrictFirstParameterRecord<ParameterType> = {
  CustomData: '?customData=',
  StaticData: '?staticData=',
  Page: '?page=',
  Conversion: '?conversion=',
  Geolocation: '?geolocation=',
  Experiment: '?experiment=',
  ValuesCountMap: '?valuesCountMap=',
  Id: '?id=',
  Nonce: '?nonce=',
  Country: '?country=',
  Environment: '?environment=',
  City: '?city=',
  Region: '?region=',
  Latitude: '?latitude=',
  Longitude: '?longitude=',
  PostalCode: '?postalCode=',
  SdkName: '?sdkName=',
  SdkVersion: '?sdkVersion=',
  BrowserIndex: '?browserIndex=',
  BrowserVersion: '?browserVersion=',
  SiteCode: '?siteCode=',
  VisitorCode: '?visitorCode=',
  CurrentVisit: '?currentVisit=',
  MaxNumberPreviousVisits: '?maxNumberPreviousVisits=',
  Negative: '?negative=',
  Revenue: '?revenue=',
  Title: '?title=',
  Os: '?os=',
  OsIndex: '?osIndex=',
  Browser: '?browser=',
  ReferrersIndices: '?referrersIndices=',
  Overwrite: '?overwrite=',
  Index: '?index=',
  Href: '?href=',
  VariationId: '?variationId=',
  DeviceType: '?deviceType=',
  GoalId: '?goalId=',
  Ts: '?ts=',
  Key: '?key=',
  MappingIdentifier: '?mappingIdentifier=',
  MappingValue: '?mappingValue=',
  Kcs: '?kcs=',
  Personalization: '?personalization=',
  UserAgent: '?userAgent=',
  BodyUa: '?bodyUa=',
  Cbs: '?cbs=',
  Metadata: '?metadata=',
  VisitNumber: '?visitNumber=',
  TimeSincePreviousVisit: '?timeSincePreviousVisit=',
};
export const UrlQuery: StrictQueryRecord<QueryType> = {
  Sse: 'sse?siteCode=',
  Map: 'map?siteCode=',
  Events: 'events?siteCode=',
  Visitor: 'visitor?siteCode=',
};
export const UrlTracking: StrictTrackingRecord<TrackingType> = {
  Visit: 'visit/',
  Map: 'map/',
};

export const DEFAULT_DOMAINS: DomainsType = {
  [UrlType.DataApi]: 'data.kameleoon.io',
  [UrlType.Events]: 'events.kameleoon.eu',
  [UrlType.ClientConfiguration]: 'sdk-config.kameleoon.eu',
};
